import "./key-metric-block.scss";